import { useState, useEffect } from 'react';
import { collection, getDocs, query, limit } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { Rank } from '@/types';

const DEFAULT_RANKS: Rank[] = [];

export function useRanks() {
  const [ranks, setRanks] = useState<Rank[]>(DEFAULT_RANKS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRanks = async () => {
      try {
        const settingsQuery = query(
          collection(db, 'systemSettings'),
          limit(1)
        );
        const settingsSnapshot = await getDocs(settingsQuery);

        if (!settingsSnapshot.empty) {
          const settings = settingsSnapshot.docs[0].data();
          if (settings.ranks && Array.isArray(settings.ranks) && settings.ranks.length > 0) {
            // Sort by order
            const sortedRanks = [...settings.ranks].sort((a, b) => a.order - b.order);
            setRanks(sortedRanks);
          } else {
            setRanks(DEFAULT_RANKS);
          }
        } else {
          setRanks(DEFAULT_RANKS);
        }
      } catch (error) {
        console.error('Error fetching ranks:', error);
        setRanks(DEFAULT_RANKS);
      } finally {
        setLoading(false);
      }
    };

    fetchRanks();
  }, []);

  return { ranks, loading };
}

export { DEFAULT_RANKS };
